<template>
  <div>
	<div class="data17">
		<div class="data17Til">{{list.data.menuTitle}}</div>
		<div class="data17Cen">
			<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
		</div>
		<div class="data17Img">
			<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`" >
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list.data.urls" :key="index">
						<img :src="item" v-if="list.data.type==1" />
						<template v-else>
							<template v-if="headerShow">
								<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
							</template>
							<template v-else>
								<video :src="item"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
							</template>
						</template>
					</div>
				</div>
				<template v-if="!headerShow">
					<div class="swiper-hexin-prev"  :style="{
						left:`30px`,
						display:qhShow?activeIndex==0?'none':'block':'none'
					}" @click="prev()">
						<img src="@/assets/index/hxz.png" />
					</div>
					<div class="swiper-hexin-next" :style="{
						right:`30px`,
						display:qhShow?activeIndex==list.data.urls.length-1?'none':'block':'none'
					}" @click="next()">
						<img src="@/assets/index/hxy.png" />
					</div>
				</template>
			</div>
			<!-- <img src="@/assets/product/page6/sp.png" /> -->
			<!-- <video></video> -->
		</div>
		<div class="data17ImgList">
			<div class="swiper-canpin" :class="`swiper-canpin${list.index}`" >
				<div class="swiper-wrapper">
					<div class="swiper-slide swiper-slide-Two" v-for="(item,index) in list.data.imgs" :key="index" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'">
						<div class="data17ImgListFor" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'">
							<img :src="item" :style="list.data.imgs.length<4?'width: 375px':'width: 277px'" />
							<!-- <img :src="item" v-if='list.one_type_id==2' :style="{
								width:'375px',
								height:'260px'
							}" />
							<img :src="item" v-else :style="{
								width:'375px',
								height:'375px'
							}" /> -->
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="data17ImgListFor" v-for="(item,index) in list.data.imgs" :key="index">
				<img :src="item" />
			</div> -->
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		list:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {
		spImgList:[
			{
				img:require("@/assets/product/page6/img1.png")
			},
			{
				img:require("@/assets/product/page6/img2.png")
			},
			{
				img:require("@/assets/product/page6/img3.png")
			},
			{
				img:require("@/assets/product/page6/img4.png")
			},
		],
		activeIndex:1,
		qhShow:true
      }
    },
    mounted() {
		let t=this;
		let name='.swiper-data2-banner'+this.list.index;
		const mySwiper = new this.$swiper(name, {
			// 方向
			direction: 'horizontal',
			// 自动播放
			autoplay: false,
			slidesPerView: 1,
			allowTouchMove: this.list.data.urls.length > 1 ? true : false,
			navigation: {
				prevEl: ".swiper-hexin-prev",
				nextEl: ".swiper-hexin-next",
			},
			on: {
				slideChangeTransitionStart(e) {
					t.activeIndex = this.activeIndex;
				},
		
			},
		});
		let nameTwo='.swiper-canpin'+this.list.index;
		const mySwiperTwo = new this.$swiper(nameTwo, {
			// 方向
			direction: 'horizontal',
			slidesPerView: 'auto', // 每屏显示3个滑块
			slidesPerGroup: 1, // 每次滑动3个滑块
			spaceBetween:30,
			freeMode: false,
			// 自动播放
			autoplay: false,
		});
		this.$nextTick(function(){
			if(this.list.data.urls.length<2){
				this.qhShow=false
			}
		})
    },
    methods: {
		next(){
			console.log("right")
			let t=this;
			if(t.activeIndex==t.list.data.urls.length-1){
				t.activeIndex = 0;
			}else{
				t.activeIndex++;
			}
			// this.mySwiper.slideNext()
		},
		prev(){
			let t=this;
			if(t.activeIndex==0){
				t.activeIndex = t.list.data.urls.length-1;
			}else{
				t.activeIndex--;
			}
			console.log("left")
			// this.mySwiper.slidePrev()
		},
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data17{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.data17Til{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 40px;
	}
	.data17Cen{
		font-size: 18px;
		
		font-weight: 300;
		color: #000000;
		margin-bottom: 40px;
		>div{
			white-space: pre-line;
		}
	}
	.data17Img{
		width: 100%;
		height: 600px;
		margin-bottom: 40px;
		img{
			width: 100%;
			height: 600px;
		}
		video{
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	}
	.data17ImgList{
		display: flex;
		align-items: center;
		// overflow-x: auto;
		.swiper-canpin{
			width: 1200px;
			overflow: hidden;
			.swiper-slide-Two{
				width: 375px;
			}
			.swiper-slide-Two:not(:last-child){
				margin-right: 31px;
			}
		}
		.data17ImgListFor:not(:last-child){
			margin-right: 31px;
		}
		.data17ImgListFor{
			width: 375px;
			height: 230px;
			// cursor: pointer;
			position: relative;
			img{
				width: 375px;
				height: 230px;
			}
		}
		
	}
}
.swiper-data2-banner{
	overflow: hidden;
}
.swiper-slide{
	position: relative;
	img{
		width: 50vw;
		height: 600px;
		object-fit: cover;
	}
	video{
		width: 50vw;
		height: 600px;
	}
}
.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}
	@media screen and (max-width:1200px) {
		.data17{
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
		}
		.data17Til{
			font-size: 24px !important;
			margin-bottom:20px !important;
		}
		.data17Cen{
			font-size: 14px !important;
			margin-bottom:20px !important;
		}
		.data17Img{
			height: auto !important;
			margin-bottom:20px !important;
			.swiper-slide{
				width: 100% !important;
			}
			img{
				height: auto !important;
				object-fit: contain;
			}
			video{
				height: auto !important;
				object-fit: cover;
			}
		}
		.data17ImgListFor {
			height: calc(20vh - 70px) !important;
		
			img {
				width: 100px !important;
				height: 100% !important;
				object-fit: contain !important;
			}
		}
		.swiper-canpin {
			width: 100% !important;
		
			.swiper-slide-Two {
				width: 100px !important;
				margin-right: 0px !important;
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>
